export default "__VITE_ASSET__MiJPvUeQ__"